
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as document_45drivenxVG0u_45Lc_F5VkGqxQ9Ad474cuuPv3elzPfryrUTA3_454Meta } from "/opt/build/repo/node_modules/.pnpm/@nuxt+content@2.13.4_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2_nuxt@3.21.2_@emnapi+core@1.9.2_@_anomiyuh65ftjfug53kskmftru/node_modules/@nuxt/content/dist/runtime/pages/document-driven.vue?macro=true";
import { default as _91slug_9345bVYfebRyqpiKUWPyZVSy_xNrWsi0WSRI_45jA_k0ZGAMeta } from "/opt/build/repo/pages/tag/[slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/build/repo/node_modules/.pnpm/@nuxt+content@2.13.4_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2_nuxt@3.21.2_@emnapi+core@1.9.2_@_anomiyuh65ftjfug53kskmftru/node_modules/@nuxt/content/dist/runtime/pages/document-driven.vue")
  },
  {
    name: "tag-slug",
    path: "/tag/:slug()",
    meta: _91slug_9345bVYfebRyqpiKUWPyZVSy_xNrWsi0WSRI_45jA_k0ZGAMeta || {},
    component: () => import("/opt/build/repo/pages/tag/[slug].vue")
  }
]